import { render } from "./CalendarView.vue?vue&type=template&id=8393e6e0&ts=true"
import script from "./CalendarView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalendarView.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/CalendarView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8393e6e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8393e6e0', __exports__)) {
    console.log('reload')
    api.reload('8393e6e0', __exports__)
  }
  
  module.hot.accept("./CalendarView.vue?vue&type=template&id=8393e6e0&ts=true", () => {
    console.log('re-render')
    api.rerender('8393e6e0', render)
  })

}


export default __exports__